import { get, post } from "../../../api";
import url from "../../../api/apisList";
import * as types from "./actionTypes";

export const alertSnackBarAction = (alertMessage, alertStatus) => {
  return async (dispatch) => {
    dispatch({
      type: types.ALERT_SNACK_BAR_ACTION,
      alertMessage,
      alertStatus,
    });
  };
};

export const closeSnackBarAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.CLOSE_SNACK_BAR_ACTION,
    });
  };
};

export const resetAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.MY_CANDIDATES_RESET_ACTION,
    });
  };
};

export const clearCandidateDetailsAction = () => {
  return async (dispatch) => {
    dispatch({
      type: types.CLEAR_CANDIDATE_DETAILS_ACTION,
    });
  };
};

export const getActiveCandidatesAction = (userid, page, limit, searchText) => {
  let apiUrl = url("active_candidates")(userid, page, limit, searchText);

  return async (dispatch) => {
    // Dispatch loading request before API call
    dispatch({
      type: types.GET_ACTIVE_CANDIDATES_ACTION_REQUEST,
    });

    try {
      const res = await get(apiUrl);
      let activeCandidates = [];
      let total_candidates = 0;
      let pageNo = page || 1;

      if (res?.data) {
        activeCandidates = res?.data?.candidates || [];
        total_candidates = res?.data?.total || 0;
        pageNo = page || 1;
      }

      if (activeCandidates?.length > 0 && parseInt(page) === 1) {
        const candidate_id = activeCandidates?.[0].candidate_id;

        dispatch(getCandidateDetailAction(candidate_id));
      }

      // Dispatch success action even if activeCandidates is empty
      dispatch({
        type: types.GET_ACTIVE_CANDIDATES_ACTION,
        payload: activeCandidates,
        total_candidates: total_candidates,
        pageNo: pageNo,
      });
    } catch (err) {
      console.error("Error fetching active candidates:", err);
      dispatch({
        type: types.GET_ACTIVE_CANDIDATES_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCandidateDetailAction = (candidateID, userID) => {
  let apiUrl = url("candidate")(candidateID);

  return async (dispatch) => {
    dispatch({ type: types.GET_CANDIDATE_DETAIL_LOADING_ACTION });
    try {
      const res = await get(apiUrl);
      let candidate;
      let interested_jobs_daycount;
      let jobs_daycount;

      if (res?.data) {
        candidate = res?.data?.candidate;
        interested_jobs_daycount = res?.data?.interest_count;
        jobs_daycount = res?.data?.jobs_count;
      }

      if (candidate) {
        dispatch({
          type: types.GET_CANDIDATE_DETAIL_ACTION,
          payload: candidate,
          interested_jobs_daycount: interested_jobs_daycount,
          jobs_daycount: jobs_daycount,
        });
        const candidateData = {
          candidate_id: candidateID,
          user_id: userID,
        };
        dispatch(getCandidateResumeListAction(candidateData));
      } else {
        dispatch({
          type: types.GET_CANDIDATE_DETAIL_ACTION_FAIL,
          payload: new Error("Candidate details not found"),
        });
      }
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_DETAIL_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getSolrJobsCountAction = (generatedQuery) => {
  let apiUrl = url("solr_jobs");

  let body = {
    url: generatedQuery,
  };
  return async (dispatch) => {
    try {
      if (generatedQuery) {
        const res = await post(apiUrl, body);
        let solrJobsCount;

        if (res?.jobs) {
          solrJobsCount = res?.count;
        }

        dispatch({
          type: types.GET_SOLR_JOBS_COUNT_ACTION,
          payload: solrJobsCount,
        });
      }
    } catch (err) {
      dispatch({
        type: types.GET_SOLR_JOBS_COUNT_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getSolrJobsAction = (generatedQuery, pageNo) => {
  let apiUrl = url("solr_jobs");
  let body = { url: generatedQuery };

  return async (dispatch) => {
    // flip loading ON right now (no waiting)
    dispatch({ type: types.GET_SOLR_JOBS_ACTION_REQUEST });

    try {
      if (generatedQuery) {
        const res = await post(apiUrl, body);

        let solrJobs, solrJobsCount;
        if (res?.jobs) {
          solrJobs = res?.jobs;
          solrJobsCount = res?.count;
          if (res?.jobs[0]?.id) {
            dispatch(getJobDetailsAction(res?.jobs[0]?.id));
          }
        }

        dispatch({
          type: types.GET_SOLR_JOBS_ACTION,
          payload: {
            solrJobs,
            solrJobsCount,
            pageNo,
          },
        });
      }
    } catch (err) {
      dispatch({ type: types.GET_SOLR_JOBS_ACTION_FAIL, payload: err });
    }
  };
};

export const getSolrJobsWithSubmissionAction = (
  generatedQuery,
  pageNo,
  candidateId
) => {
  const apiUrl = url("solr_jobs_with_submission");
  const body = {
    url: generatedQuery,
    candidateid: candidateId,
  };

  return async (dispatch) => {
    dispatch({ type: types.GET_SOLR_JOBS_ACTION_REQUEST });

    try {
      if (!generatedQuery || !candidateId) {
        dispatch({ type: types.GET_SOLR_JOBS_ACTION_FAIL, payload: "Missing query or candidate" });
        return;
      }

      const res = await post(apiUrl, body);

      let solrJobs;
      let solrJobsCount;
      if (res?.jobs) {
        solrJobs = res.jobs;
        solrJobsCount = res.count;
        if (res.jobs[0]?.id) {
          dispatch(getJobDetailsAction(res.jobs[0].id));
        }
      }

      dispatch({
        type: types.GET_SOLR_JOBS_ACTION,
        payload: {
          solrJobs,
          solrJobsCount,
          pageNo,
        },
      });
    } catch (err) {
      dispatch({ type: types.GET_SOLR_JOBS_ACTION_FAIL, payload: err });
    }
  };
};

export const startSolrJobsRequest = (reset = false) => ({
  type: types.GET_SOLR_JOBS_ACTION_REQUEST,
  reset,
});

let jobDetailsAbortController = null;
let jobDetailsInFlightId = null;

export const getJobDetailsAction = (jobId, options = {}) => {
  const { force = false } = options;
  const apiUrl = url("job_details")(jobId);
  return async (dispatch, getState) => {
    if (!jobId) {
      try { jobDetailsAbortController?.abort(); } catch { }
      jobDetailsAbortController = null;
      jobDetailsInFlightId = null;
      dispatch({ type: types.GET_JOB_DETAILS_ACTION, payload: {} });
      return;
    }

    const existing = getState()?.myCandidatesManagement?.jobDetails;
    if (
      !force &&
      existing?.id != null &&
      String(existing.id) === String(jobId) &&
      Object.keys(existing).length > 0
    ) {
      return existing;
    }

    const { jobDetailsLoading } = getState()?.myCandidatesManagement || {};
    if (
      !force &&
      jobDetailsLoading &&
      jobDetailsInFlightId != null &&
      String(jobDetailsInFlightId) === String(jobId)
    ) {
      return;
    }

    try { jobDetailsAbortController?.abort(); } catch { }

    const controller = new AbortController();
    const { signal } = controller;
    jobDetailsAbortController = controller;
    jobDetailsInFlightId = jobId;

    dispatch({ type: types.GET_JOB_DETAILS_ACTION_REQUEST, payload: jobId });

    try {
      const response = await get(apiUrl, { signal });

      const jobDetails = response?.data?.job;
      if (jobDetails !== undefined) {
        dispatch({ type: types.GET_JOB_DETAILS_ACTION, payload: jobDetails });
      }

      if (jobDetailsAbortController?.signal === signal) {
        jobDetailsAbortController = null;
        jobDetailsInFlightId = null;
      }
    } catch (err) {
      if (err?.name === "AbortError" || err?.code === "ERR_CANCELED") {
        if (jobDetailsAbortController?.signal === signal) {
          jobDetailsAbortController = null;
          jobDetailsInFlightId = null;
        }
        return;
      }

      dispatch({ type: types.GET_JOB_DETAILS_ACTION_FAIL });

      if (jobDetailsAbortController?.signal === signal) {
        jobDetailsAbortController = null;
        jobDetailsInFlightId = null;
      }
    }
  };
};

export const getcandidateSubmissionsAction = (
  userid,
  candidateID,
  page,
  limit
) => {
  let apiUrl = url("candidate_submissions")(userid, candidateID, page, limit);

  return async (dispatch) => {
    try {
      const res = await get(apiUrl);
      let candidateSubmissions;

      if (res?.data) {
        candidateSubmissions = res?.data?.submissions;
      }

      if (candidateSubmissions && candidateSubmissions?.length > 0) {
        dispatch(selectedSubmissionAction(candidateSubmissions?.[0]));
      }

      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_ACTION,
        payload: candidateSubmissions,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const selectedSubmissionAction = (sub) => (dispatch, getState) => {
  const { selectedSubmission } = getState().myCandidatesManagement;

  // Switching submissions: seed status from the list item so left badge and
  // right stepper stay aligned while the status API loads. Do NOT null status
  // (that used to keep the previous submission's id and jump the stepper).
  if (sub?.id !== selectedSubmission?.id) {
    dispatch({
      type: types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION,
      payload: {
        loading: true,
        status_value: sub?.pStatusName ?? sub?.nStatusName ?? null,
        bench_status_id: sub?.bench_status_id ?? null,
        candidate_id: sub?.candidate_id,
        job_id: sub?.job_id,
      },
    });
  }

  dispatch({
    type: types.SELECTED_SUBMISSION_ACTION,
    payload: sub,
  });
};

export const selectedTabViewAction = (view) => (dispatch) => {
  dispatch({
    type: types.SELECTED_TAB_VIEW_ACTION,
    payload: view,
  });
};

// Clear sticky submissions selection/tab state (navbar leave/enter, etc.)
export const clearSubmissionViewStateAction = () => (dispatch) => {
  sessionStorage.removeItem("target_candidate_id");
  sessionStorage.removeItem("target_job_id");
  dispatch({
    type: types.SELECTED_SUBMISSION_ACTION,
    payload: null,
  });
  dispatch({
    type: types.GET_CANDIDATE_SUBMISSIONS_ACTION,
    payload: [],
  });
  dispatch({
    type: types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION,
    payload: {
      loading: false,
      status_value: null,
      bench_status_id: null,
      candidate_id: null,
      job_id: null,
    },
  });
  dispatch({
    type: types.SELECTED_TAB_VIEW_ACTION,
    payload: "Jobs",
  });
  dispatch({
    type: types.SET_ACTIVE_CANDIDATE_TAB,
    payload: 0,
  });
};

export const updateSubmissionsAction = (updatedData) => {
  let apiUrl = url("update_submissions");
  return async (dispatch, getState) => {
    let updatedSubmission = null;

    try {
      const res = await post(apiUrl, updatedData);

      if (
        res?.data?.success === 1 ||
        res?.data?.submission?.id ||
        res?.data?.submission?.affectedRows > 0
      ) {
        const userid = updatedData?.userid;
        const candidateID = updatedData?.candidateid;
        const jobID = updatedData?.jobid;
        await dispatch(getcandidateSubmissionsAction(userid, candidateID, 0, 20));
        await dispatch(
          getCandidateSubmissionStatusAction(
            candidateID,
            jobID
          )
        );

        if (jobID) {
          const state = getState();
          const candidateSubmissions = state.myCandidatesManagement?.candidateSubmissions || [];
          updatedSubmission = candidateSubmissions.find((sub) => sub?.job_id === jobID);
          if (updatedSubmission) {
            dispatch(selectedSubmissionAction(updatedSubmission));
          }
        }

        dispatch(openRightPanelAction(false));
      }
      dispatch({
        type: types.UPDATE_SUBMISSIONS_ACTION,
        payload: res?.data,
      });
      const returnPayload = updatedSubmission ? { ...res?.data, updatedSubmission } : res?.data;
      return returnPayload;
    } catch (err) {
      dispatch({
        type: types.UPDATE_SUBMISSIONS_ACTION_FAIL,
        payload: err.message,
      });
      throw err;
    }
  };
};

export const sendJobToCandidateAction = (
  sendJobDetails,
  updatedData,
  userId,
  candidateId,
  jobId
) => {
  let apiUrl = url("send_job_to_candidate");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, sendJobDetails);
      let sendJob;
      if (res?.data?.affectedRows > 0) {
        // dispatch(
        //   updateSubmissionsAction(updatedData, userId, candidateId, jobId)
        // );
        sendJob = res;
      }
      dispatch({
        type: types.SEND_JOB_TO_CANDIDATE_ACTION,
        payload: sendJob,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.SEND_JOB_TO_CANDIDATE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const sendProfileToVendor = (
  sendProfileDetails,
  updatedData,
  userId,
  candidateId,
  jobId,
  resume_id,
) => {
  let apiUrl = url("send_profile_to_vendor");
  return async (dispatch) => {
    try {
      // dispatch(
      //   updateSubmissionsAction(updatedData, userId, candidateId, jobId)
      // );

      if (resume_id) {
        var profileDetails = {
          ...sendProfileDetails,
          resumeid: resume_id,
        };

        const res = await post(apiUrl, profileDetails);

        if (res?.success === 0 || res?.data === "Bad request") {
          throw new Error(res?.error?.code === "ENOENT" ? `Attachment not found on server: ${res?.error?.path}` : res?.error?.message || res?.data || "Failed to send email");
        }

        let sendJob;
        if (res?.data?.affectedRows > 0) {
          sendJob = res?.data;
          // dispatch(
          //   updateSubmissionsAction(updatedData, userId, candidateId, jobId)
          // );
        }
        dispatch({
          type: types.SEND_PROFILE_TO_VENDOR,
          payload: sendJob,
        });
        let msg = "";

        dispatch(alertSnackBarAction(msg, "success"));
      } else {
        throw new Error("Resume not selected");
      }
    } catch (err) {
      let msg = err?.message ? err.message : err ? err : "Something went wrong";
      dispatch(alertSnackBarAction(msg, "error"));

      dispatch({
        type: types.SEND_PROFILE_TO_VENDOR_FAIL,
        payload: err?.message,
      });
    }
  };
};

export const sendCandidateProfileToVendors = (
  sendProfileDetails,
  userId,
  candidateId,
  jobIds,
  resume_id
) => {
  const apiUrl = url("send_candidate_profile_to_vendors");
  return async (dispatch) => {
    try {
      if (!resume_id) {
        throw new Error("Resume not selected");
      }
      if (!jobIds?.length) {
        throw new Error("Select at least one job");
      }

      const profileDetails = {
        ...sendProfileDetails,
        resumeid: resume_id,
        candidateid: candidateId,
        userid: userId,
        jobids: jobIds,
      };

      const res = await post(apiUrl, profileDetails);

      if (res?.success === 0 || res?.data === "Bad request") {
        const apiError =
          typeof res?.error === "string"
            ? res.error
            : res?.error?.code === "ENOENT"
              ? `Attachment not found on server: ${res?.error?.path}`
              : res?.error?.message || res?.data || "Failed to send email";
        throw new Error(apiError);
      }

      dispatch({
        type: types.SEND_PROFILE_TO_VENDOR,
        payload: res?.data,
      });
      return res;
    } catch (err) {
      const msg = err?.message ? err.message : err ? err : "Something went wrong";
      dispatch(alertSnackBarAction(msg, "error"));
      dispatch({
        type: types.SEND_PROFILE_TO_VENDOR_FAIL,
        payload: err?.message,
      });
      throw err;
    }
  };
};

export const rateConfirmationAction = (
  rate,
  updatedData,
  userId,
  candidateId,
  jobId,
  options = {}
) => {
  let apiUrl = url("rate_confirmation");
  // rateOnly: edit existing rate without status/step advance (no stepper flicker)
  const { rateOnly = false } = options;
  return async (dispatch, getState) => {
    try {
      if (rate?.submissionid == null || String(rate.submissionid).trim() === "") {
        throw new Error("Missing submission id for rate update");
      }

      const res = await post(apiUrl, rate);
      const submissionResult = res?.data?.submission ?? res?.data;
      const rowsTouched = Number(
        submissionResult?.affectedRows ??
          submissionResult?.changedRows ??
          0
      );
      // MySQL can return affectedRows=0 when the value is unchanged; still treat
      // API success as OK so edits/re-saves don't look like failures.
      const apiOk = Number(res?.success) === 1 || rowsTouched > 0;
      if (!apiOk) {
        throw new Error(res?.data?.error || res?.error || "Rate update failed");
      }

      const rateDetails = res?.data ?? { submission: submissionResult };
      const state = getState().myCandidatesManagement;
      const currentSubmission = state?.selectedSubmission;
      const nextRate =
        rate?.rate != null && String(rate.rate).trim() !== ""
          ? rate.rate
          : currentSubmission?.s_rate;

      if (currentSubmission && nextRate != null) {
        const patched = { ...currentSubmission, s_rate: nextRate };
        dispatch({
          type: types.SELECTED_SUBMISSION_ACTION,
          payload: patched,
        });
        // Keep left-list / schedule form in sync without a full refetch
        const list = state?.candidateSubmissions || [];
        if (list.length) {
          dispatch({
            type: types.GET_CANDIDATE_SUBMISSIONS_ACTION,
            payload: list.map((sub) =>
              Number(sub.submission_id) === Number(rate.submissionid) ||
              (sub.job_id != null &&
                Number(sub.job_id) === Number(currentSubmission.job_id) &&
                Number(sub.candidate_id) ===
                  Number(currentSubmission.candidate_id))
                ? { ...sub, s_rate: nextRate }
                : sub
            ),
          });
        }
      }

      // First confirmation advances workflow; edits only save the rate
      if (!rateOnly && updatedData) {
        await dispatch(updateSubmissionsAction(updatedData));
      }

      dispatch({
        type: types.RATE_CONFIRMATION_ACTION,
        payload: rateDetails,
      });
      return rateDetails;
    } catch (err) {
      dispatch({
        type: types.RATE_CONFIRMATION_ACTION_FAIL,
        payload: err.message,
      });
      throw err;
    }
  };
};

export const interviewScheduleAction = (
  interviewDetails,
  updatedData,
  userId,
  candidateId,
  jobId
) => {
  let apiUrl = url("interview_schedule");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, interviewDetails);
      let Details;
      if (res?.data?.affectedRows > 0) {
        Details = res?.data;
        dispatch(
          updateSubmissionsAction(updatedData, userId, candidateId, jobId)
        );
      }
      dispatch({
        type: types.INTERVIEW_SCHEDULE_ACTION,
        payload: Details,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.INTERVIEW_SCHEDULE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};
export const updateInterviewScheduleAction = (
  interviewDetails,
  updatedData
) => {
  let apiUrl = url("update_interview");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, interviewDetails);
      let Details;
      // await dispatch(updateSubmissionsAction(updatedData));

      if (res?.data?.affectedRows > 0) {
        Details = res?.data;
        await dispatch(updateSubmissionsAction(updatedData));
      }
      dispatch({
        type: types.UPDATE_INTERVIEW_SCHEDULE_ACTION,
        payload: Details,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_INTERVIEW_SCHEDULE_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCandidateDocuments = (candidateID, userid) => {
  let apiUrl = url("candidate_documents")(candidateID, userid);
  return async (dispatch) => {
    try {
      dispatch({
        type: types.GET_CANDIDATE_DOCUMENTS_ACTION,
        payload: [],
      });

      let res = await get(apiUrl);
      let candidateDocuments;
      if (res?.data) {
        candidateDocuments = res?.data?.documents;
      }
      dispatch({
        type: types.GET_CANDIDATE_DOCUMENTS_ACTION,
        payload: candidateDocuments,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_DOCUMENTS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const creteNotificationAction = (NotificationDetails) => {
  let apiUrl = url("create_notification");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, NotificationDetails);
      if (res?.success == 1) {
      }
      dispatch({
        type: types.CREATE_NOTIFICATION_ACTION,
        payload: res?.data,
      });
    } catch (err) {
      dispatch({
        type: types.CREATE_NOTIFICATION_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const openRightPanelAction = (status) => (dispatch) => {
  dispatch({
    type: types.OPEN_RIGHT_PANEL_ACTION,
    payload: status,
  });
};

export const getCandidateInterestedJobs = (candidateID) => {
  let apiUrl = url("get_interested_jobs_candidate")(candidateID);
  return async (dispatch) => {
    try {
      dispatch({ type: types.GET_CANDIDATE_INTERESTED_JOBS_ACTION_REQUEST });
      let res = await get(apiUrl);
      let candidateInterestedJobs;
      if (res?.data) {
        candidateInterestedJobs = res?.data;
      }
      dispatch({
        type: types.GET_CANDIDATE_INTERESTED_JOBS_ACTION,
        payload: candidateInterestedJobs,
      });
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_INTERESTED_JOBS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const setSearchInputs = (inputs) => (dispatch) => {
  const data = inputs;
  dispatch({
    type: types.SET_SEARCH_INPUTS,
    payload: data,
  });
};

export const getSearchSuggestions = (data) => {
  let apiUrl = url("get_search_suggestions");
  return async (dispatch) => {
    try {
      let res = await post(apiUrl, data);
      let suggestions;
      if (res?.data) {
        suggestions = res?.data;
      }
      dispatch({
        type: types.GET_SEARCH_SUGGESTIONS_ACTION,
        payload: suggestions,
      });
    } catch (err) {
      dispatch({
        type: types.GET_SEARCH_SUGGESTIONS_ACTION_FAIL,
        payload: err.message,
      });
    }
  };
};

export const getCandidateResumeListAction = (candidateData) => {
  let apiUrl = url("get_candidate_resume_list");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, candidateData);
      let candidateResumeList;
      if (res?.success === 1) {
        candidateResumeList = res?.data;
      }
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION,
        payload: candidateResumeList,
      });
      return res;
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATES_RESUMES_LIST_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const getCandidateSubmissionStatusAction = (candidateid, jobid) => {
  let apiUrl = url("get_submission_status");

  return async (dispatch) => {
    try {
      const res = await post(apiUrl, { candidateid, jobid });
      if (res?.success === 1 && res?.data[0]) {
        const row = res.data[0];
        const status = row?.status_value;
        const submissionid = row?.id;
        dispatch({
          type: types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION,
          payload: {
            ...row,
            // Always tag which submission this status belongs to
            candidate_id: row?.candidate_id ?? candidateid,
            job_id: row?.job_id ?? jobid,
          },
        });

        window.dispatchEvent(
          new CustomEvent("statusUpdate", {
            detail: { newStatus: status, submissionId: submissionid },
          })
        );

        dispatch({
          type: types.UPDATE_SUBMISSION_STATUS,
          payload: { submissionId: submissionid, newStatus: status },
        });
      }
    } catch (err) {
      dispatch({
        type: types.GET_CANDIDATE_SUBMISSIONS_STATUS_ACTION_FAIL,
        payload: err?.message || err,
      });
    }
  };
};


export const selectedResume = (resume) => (dispatch) => {
  dispatch({
    type: types.SELECTED_RESUME_ACTION,
    payload: resume,
  });
};

export const getSubmissionResumeDetails = (resume_id) => {
  let apiUrl = url("get_submission_resume_details");

  return async (dispatch) => {
    try {
      const data = {
        resume_id: resume_id,
      };
      const res = await post(apiUrl, data);
      let resume;

      if (res?.data) {
        resume = res?.data?.resume;
      }

      //console.log(resume);
      if (resume) {
        dispatch({
          type: types.GET_SUBMISSION_RESUME_DETAILS_ACTION,
          payload: resume,
        });
      }
    } catch (err) {
      dispatch({
        type: types.GET_SUBMISSION_RESUME_DETAILS_ACTION_FAIL,
        payload: err,
      });
    }
  };
};

export const updateViewedStatus = (candidateid, jobid) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.UPDATE_VIEWED_STATUS_REQUEST });

      const response = await post(url("update_viewed_status"), {
        candidateid,
        jobid,
      });

      dispatch({
        type: types.UPDATE_VIEWED_STATUS_SUCCESS,
        payload: response.data?.data,
      });
      dispatch({
        type: types.UPDATE_VIEWED_STATUS_LOCAL,
        payload: { candidate_id: candidateid, job_id: jobid },
      });

      return response.data;

    } catch (error) {
      dispatch({
        type: types.UPDATE_VIEWED_STATUS_FAIL,
        payload: error,
      });
    }
  };
};

export const setActiveCandidateTab = (tab) => ({
  type: types.SET_ACTIVE_CANDIDATE_TAB,
  payload: tab,
});

